export const data = {
  titles: {
    propertyList: 'Invoice List',
    search: 'Search',
    filter: 'Filter'
  },
  tableHeading: {
    admin: [
      'Property Type',
      'Property Name',
      'Landlord Name',
      'Total Amount',
      'Due in',
      'Status',
      'Edit'
    ],
    landlord: [
      'Property Name',
      'Tenant ID',
      'Sent By',
      'Invoice Month',
      'CC Emails',
      'Sent On',
      'Action'
    ],
    manager: [
      'Property Name',
      'Tenant ID',
      'Sent By',
      'Invoice Month',
      'CC Emails',
      'Sent On',
      'Action'
    ],
    tenant: [
      'Property Type',
      'Property Name',
      'Landlord Name',
      'Status',
      'Details'
    ]
  },
  cta: {
    addProperty: 'Add New Property'
  }
};

export const statusClass = (status, classes) => {
  if (status === 'active') {
    return classes.active;
  }
  if (status === 'draft') {
    return classes.draft;
  }
  if (status === 'inactive') {
    return classes.inactive;
  }
  if (status === 'disabled') {
    return classes.disabled;
  }
};
export const propertiesUserType = {
  admin: 'Admin',
  landlord: 'Landlord',
  tenant: 'Tenant'
};
